// Passwortregeln wie im Backend (AUTH_PASSWORD_VALIDATORS). Häufige Passwörter prüft nur der Server.
export const MIN_PASSWORD_LENGTH = 8;

export interface PasswordRuleState {
  length: boolean;
  numeric: boolean;
  similar: boolean;
  met: boolean;
}

// similarTo: Nutzerdaten (E-Mail, Namen); null = Ähnlichkeit wird nur vom Server geprüft
export function checkPasswordRules(password: string, similarTo: string[] | null = null): PasswordRuleState {
  const pw = (password || '').toLowerCase();
  const length = pw.length >= MIN_PASSWORD_LENGTH;
  const numeric = pw.length > 0 && !/^\d+$/.test(pw);
  let similar = pw.length > 0;
  if (similarTo) {
    const parts = similarTo.flatMap(p => [p, p.includes('@') ? p.split('@')[0] : ''])
      .map(p => (p || '').toLowerCase())
      .filter(p => p.length >= 3);
    similar = pw.length > 0 && !parts.some(p => pw.includes(p));
  }
  return { length, numeric, similar, met: length && numeric && similar };
}

const PASSWORD_ERROR_KEYS: Record<string, string> = {
  password_too_common: 'acceptPage.errorCommon',
  password_too_short: 'acceptPage.errorShort',
  password_entirely_numeric: 'acceptPage.errorNumeric',
  password_too_similar: 'acceptPage.errorSimilar'
};

// Übersetzungsschlüssel zu den Fehlercodes des Servers; unbekannte Codes -> null (Server-Meldung anzeigen)
export function passwordErrorKeys(codes: string[] | undefined): (string | null)[] {
  return (codes || []).map(c => PASSWORD_ERROR_KEYS[c] || null);
}

// Server-Meldungen der Passwortregeln in der gewählten Sprache
export function translatePasswordErrors(translate: { instant(key: string): string }, messages: string[], codes: string[] | undefined): string[] {
  const keys = passwordErrorKeys(codes);
  return messages.map((msg, i) => (keys[i] ? translate.instant(keys[i] as string) : msg));
}
